/**
 * `div.orline` → `or-divider` (process/08-COMPONENT-CATALOGUE.md: "the *or* rule between two ways
 * of doing the same thing"). New W173 — catalogued since the auth family's own spec review but
 * never built: `a-signin`'s own two sign-in methods (password, SSO) sat directly against each
 * other with no divider at all. gap 10px → --sp-5 (0 delta); margin 18px 0 → --sp-9 (+2px, an
 * exact tie that rounds up per §33.9's own rule); label font-size 10.5px → --fs-small (+0.5px).
 */
export function OrDivider({ label }: { label: string }) {
  return (
    <div data-cmp="or-divider" className="flex items-center gap-5 my-9">
      <span className="flex-1 h-px bg-bd" />
      <span className="text-small text-muted not-italic">{label}</span>
      <span className="flex-1 h-px bg-bd" />
    </div>
  )
}
